import { render, staticRenderFns } from "./cxReport.vue?vue&type=template&id=5b0277a6&"
import script from "./cxReport.vue?vue&type=script&lang=js&"
export * from "./cxReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports